import { SparkLineChart as MuiSparkLineChart, SparkLineChartProps } from '@mui/x-charts';
import React from 'react';

import { useChartLocale } from 'components/charts/hooks/use-chart-locale';
import ChartThemeScope from 'components/charts/theme/chart-theme-scope';
import { ChartSurfaceProps } from 'components/charts/types/chart-surface.type';

const SparklineChart = React.forwardRef<
  HTMLDivElement,
  Omit<SparkLineChartProps, 'data'> & ChartSurfaceProps & { data: (number | null)[] }
>(function SparklineChart({ showTooltip = true, showHighlight = true, dark, valueFormatter, data, yAxis, ...props }, ref) {
  const { formatValue } = useChartLocale();

  return (
    <ChartThemeScope dark={dark}>
      <MuiSparkLineChart
        {...props}
        ref={ref}
        // The type says number[], but data goes straight to a line series, which draws null as a gap.
        data={data as number[]}
        // A sparkline has room for one or two ticks, so a "nice" domain can squash the line into a third of its height.
        yAxis={{ domainLimit: 'strict', ...yAxis }}
        showTooltip={showTooltip}
        showHighlight={showHighlight}
        valueFormatter={valueFormatter ?? formatValue}
      />
    </ChartThemeScope>
  );
});

export default SparklineChart;
